import CxDropdown from './dropdown.vue'
import CxDropdownMenu from './dropdown-menu.vue'
import CxDropdownItem from './dropdown-item.vue'

CxDropdown.Menu = CxDropdownMenu
CxDropdown.Item = CxDropdownItem
export default CxDropdown



// WEBPACK FOOTER //
// ./src/components/Dropdown/index.js